module.exports = __webpack_public_path__ + "static/maarif1-052d5d2560d67255fabb138bc30ef937.png";